var render = function render(){var _vm=this,_c=_vm._self._c;return _c('input-select',{attrs:{"options":_vm.options,"label":_vm.label,"value":_vm.model,"required":""},on:{"change":_vm.setValue},scopedSlots:_vm._u([{key:"item",fn:function({ item }){return [_c('v-radio-group',{attrs:{"value":_vm.model}},[_c('v-radio',{attrs:{"label":item.text,"color":"primary","value":item.value}})],1)]}}])})
}
var staticRenderFns = []

export { render, staticRenderFns }